module.exports = __webpack_public_path__ + "img/electrician_thumbnail-400x300.0f1c4231.jpg";